export const MAINTENANCE_Z_INDEX = 999;
export const HEADER_MENU_Z_INDEX = 800;
export const HEADER_SUB_MENU_Z_INDEX = 600;
export const DONATE_BUTTON_Z_INDEX = 590;

export const TEXT_Z_INDEX = 1;

export const HEADER_WEB_HEIGHT = 146;
export const HEADER_MOBILE_HEIGHT = 48;
